export default __webpack_public_path__ + "static/media/chip_1000.4e690dc9.svg";